/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromSignup from '../actions/signup.action';

export interface SignupState {
  userData: any;
  success: boolean;
  updateSuccess: boolean;
  failed: boolean;
  loading: boolean;
  userActive: boolean;
  selectedPlan: any;
  errorMessage: string;
}

export const initialState = {
  userData: {},
  success: false,
  updateSuccess: false,
  failed: false,
  loading: false,
  userActive: false,
  selectedPlan: {},
  errorMessage: null,
};

export function reducer(state = initialState, action: fromSignup.SignupAction): SignupState {
  switch (action.type) {
    case fromSignup.RESET_USER: {
      return { ...state, userData: {}, success: false };
    }

    case fromSignup.SAVE_USER_FOR_SIGNUP:
    case fromSignup.LOAD_USER_FOR_SIGNUP: {
      return {
        ...state,
        userData: action.payload,
      };
    }

    case fromSignup.CLAIM_ACCOUNT:
    case fromSignup.USER_SIGNUP: {
      return {
        ...state,
        loading: true,
        success: false,
        failed: false,
      };
    }

    case fromSignup.CLAIM_ACCOUNT_SUCCESS:
    case fromSignup.USER_SIGNUP_SUCCESS: {
      return {
        ...state,
        userData: action.payload.user,
        loading: false,
        success: true,
        failed: false,
      };
    }

    case fromSignup.CLAIM_ACCOUNT_FAIL:
    case fromSignup.USER_SIGNUP_FAIL: {
      return {
        ...state,
        loading: false,
        success: false,
        failed: true,
        errorMessage: action.payload,
      };
    }

    case fromSignup.SET_USER_PLAN: {
      return {
        ...state,
        loading: false,
        success: false,
        failed: false,
        userActive: false,
        errorMessage: null,
        selectedPlan: action.payload,
      };
    }

    case fromSignup.UPDATE_USER: {
      return {
        ...state,
        loading: true,
        failed: false,
        success: false,
      };
    }

    case fromSignup.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        userData: action.payload.user || action.payload,
        loading: false,
        updateSuccess: true,
        userActive: true,
      };
    }

    case fromSignup.UPDATE_USER_FAIL: {
      return {
        ...state,
        loading: false,
        failed: true,
        errorMessage: action.payload,
      };
    }
  }
  return state;
}

export const getSignupFailed = (state: SignupState) => ({ failed: state.failed, message: state.errorMessage });
export const getSignupLoading = (state: SignupState) => state.loading;
export const getSignupSuccess = (state: SignupState) => state.success;
export const getUserUpdateSuccess = (state: SignupState) => state.updateSuccess;
export const getUserPlan = (state: SignupState) => state.selectedPlan;
export const getUserActive = (state: SignupState) => state.userActive;
export const getUserData = (state: SignupState) => state.userData;
